import Clarity from "@microsoft/clarity";
import { createSIWEConfig, formatMessage } from "@reown/appkit-siwe";
import { getAddress } from "viem";
import Cookies from "js-cookie";
const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api/siwe-session";

// Normalize the address (checksum)
const normalizeAddress = (address) => {
    try {
        const splitAddress = address.split(":");
        const extractedAddress = splitAddress[splitAddress.length - 1];
        const checksumAddress = getAddress(extractedAddress);
        splitAddress[splitAddress.length - 1] = checksumAddress;
        const normalizedAddress = splitAddress.join(":");

        return normalizedAddress;
    } catch (error) {
        return address;
    }
};

// call the server to get a nonce
const getNonce = async () => {
    const res = await fetch(BASE_URL + "/nonce", {
        method: "GET",
        credentials: "include",
    });
    if (!res.ok) {
        throw new Error("Network response was not ok");
    }
    const nonce = await res.text();
    // console.log("Nonce:", nonce);
    return nonce;
};

// call the server to verify the message
const verifyMessage = async ({ message, signature }) => {
    try {
        // delay 2 seconds
        // await new Promise((resolve) => setTimeout(resolve, 2000));
        const marketingClickId = Cookies.get("marketing_clickid");
        const marketingClickIdLocalStorage = localStorage.getItem("marketing_clickid");

        const response = await fetch(BASE_URL + "/verify", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            mode: "cors",
            body: JSON.stringify({
                message,
                signature,
                marketingClickId: marketingClickId || marketingClickIdLocalStorage,
            }),
            credentials: "include",
        });

        if (!response.ok) {
            console.error("Verify message failed:", await response.text());
            return false;
        }
        const result = await response.json();

        // Store user data
        localStorage.setItem("siwe-user", JSON.stringify(result));

        // Dispatch auth complete event
        window.dispatchEvent(
            new CustomEvent("SIWE_AUTH_COMPLETE", {
                detail: result,
            })
        );

        return true;
    } catch (error) {
        console.error("Verification error:", error);
        return false;
    }
};

// call the server to get the session
const getSession = async () => {
    const res = await fetch(BASE_URL + "/session", {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });
    if (!res.ok) {
        throw new Error("Network response was not ok");
    }

    const data = await res.json();
    // console.log("Session data:", data);

    const isValidData =
        typeof data === "object" &&
        typeof data.address === "string" &&
        data.address.startsWith("0x") &&
        typeof data.chainId === "number" &&
        data.chainId > 0;
    Clarity.identify(data.address);
    Clarity.event("SIWE_AUTH_COMPLETE", {
        address: data.address,
        chainId: data.chainId,
    });

    return isValidData ? data : null;
};

// call the server to sign out
const signOut = async () => {
    const res = await fetch(BASE_URL + "/signout", {
        method: "GET",
        credentials: "include",
    });
    if (!res.ok) {
        throw new Error("Network response was not ok");
    }

    const data = await res.json();
    return data == "{}";
};

export const autoSIWE = (chains) => {
    return createSIWEConfig({
        signOutOnAccountChange: true,
        signOutOnNetworkChange: true,
        getMessageParams: async () => ({
            domain: window.location.host,
            uri: window.location.origin,
            chains: chains.map((chain) => parseInt(chain.id.toString())),
            statement:
                "Welcome to BidCoin! Please sign this message to prove ownership of wallet to login.\n\nThis action does not cost any gas.",
        }),
        createMessage: ({ address, ...args }) => {
            // normalize the address in case you are not using our library in the backend
            return formatMessage(args, normalizeAddress(address));
        },
        getNonce,
        getSession,
        verifyMessage,
        signOut,
    });
};
